
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/institutions",
      function () {
        return require("private-next-pages/docs/institutions/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/institutions"])
      });
    }
  